import { useMutation } from 'react-query'

import { CustomEvent } from '../../../enums/customEvent'
import { formatDate } from '../../../utils'
import { APIError } from '../../../utils/api'
import { dispatchCustomEvent } from '../../../utils/customEvent'
import { updateBankAccount } from '../query-api'

interface UseUpdateConnectedBankAccountProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export interface UpdateConnectedBankAccountPayload {
  organizationId: string
  bankAccountId: string
  customAccountName?: string | null
  reconciliationStartDate?: Date | null
}

export const useUpdateConnectedBankAccount = (props?: UseUpdateConnectedBankAccountProps) => {
  const { onError, onSuccess } = props || {}

  const { mutate: update, isLoading: isProcessing } = useMutation(
    ({
      organizationId,
      bankAccountId,
      customAccountName,
      reconciliationStartDate,
    }: UpdateConnectedBankAccountPayload) =>
      updateBankAccount({
        organizationId,
        bankAccountId,
        customAccountName,
        reconciliationStartDate:
          reconciliationStartDate === undefined ? undefined : (formatDate(reconciliationStartDate) ?? null),
      }),
    {
      onError,
      onSuccess: (_, { reconciliationStartDate }) => {
        if (reconciliationStartDate !== undefined) {
          dispatchCustomEvent(CustomEvent.BankAccountReconciliationStartDateUpdated)
        }
        onSuccess?.()
      },
    },
  )

  return {
    update,
    isProcessing,
  }
}
